@if (hasSource()) {
  <section class="qs" [class.qs--edited]="!!edited()">

    <header class="qs__head">
      <i class="fa-solid fa-file-import qs__icon"></i>
      <span class="qs__title">{{ 'QUESTION_SOURCE.TITLE' | translate }}</span>

      @if (edited()) {
        <span class="badge bg-primary-subtle text-primary-emphasis border qs__badge">
          {{ 'QUESTION_SOURCE.EDITED' | translate }}
        </span>
      }
    </header>

    <p class="qs__origin">
      @if (source()?.fileName) {
        <span class="qs__file">{{ source()!.fileName }}</span>
      }
      @if (source()?.row != null) {
        <span class="qs__where">
          {{ 'QUESTION_SOURCE.LOCATION' | translate:{ row: source()!.row, page: source()!.page ?? 1 } }}
        </span>
      }
    </p>

    @if (edited(); as e) {

      <p class="qs__note">
        @if (e.at) {
          {{ 'QUESTION_SOURCE.EDITED_ON' | translate:{ date: (e.at | date:'dd/MM/yyyy') } }}
        } @else {
          {{ 'QUESTION_SOURCE.EDITED_NOTE' | translate }}
        }
      </p>

      <!-- Ce bloc montre LE DOCUMENT, pas la question : celle-ci est déjà à
           l'écran juste en dessous, et c'est leur confrontation qui répond à
           « d'où sort cette formulation ? ». -->
      <div class="qs__original">
        <div class="qs__label">{{ 'QUESTION_SOURCE.DOCUMENT_SAID' | translate }}</div>

        @if (e.original.title) {
          <p class="qs__statement"><app-math-text [text]="e.original.title"></app-math-text></p>
        }

        @if (answers().length > 0) {
          <ul class="qs__answers">
            @for (a of answers(); track $index) {
              <li [class.qs__answer--correct]="a.isCorrect">
                <i class="fa-solid"
                   [class.fa-circle-check]="a.isCorrect"
                   [class.fa-circle]="!a.isCorrect"
                   [attr.aria-label]="a.isCorrect
                     ? ('QUESTION_SOURCE.WAS_CORRECT' | translate)
                     : null"></i>
                <span><app-math-text [text]="a.content"></app-math-text></span>
              </li>
            }
          </ul>
        }

        @if (fields().length > 0) {
          <dl class="qs__fields">
            @for (f of fields(); track f.labelKey) {
              <div class="qs__field">
                <dt>{{ f.labelKey | translate }}</dt>
                <dd>{{ f.before }}</dd>
              </div>
            }
          </dl>
        }
      </div>
    }

  </section>
}
